import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({providedIn: 'root'})
export class AppBackgroundOverlayService {

    public overlayDisplayed$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    constructor() { }
    
}